export default function debounce(func, wait, immediate) {
  let timeout;
  let pendingContext;
  let pendingArgs;
  let lastCall;

  const debounced = function() {
    pendingContext = this;
    pendingArgs = arguments;
    const later = function() {
      timeout = null;
      const args = pendingArgs;
      pendingArgs = null;
      if (!immediate) { lastCall = func.apply(pendingContext, args); }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) { lastCall = func.apply(pendingContext, pendingArgs); }
  };

  debounced.flush = function() {
    if (!timeout) {
      return lastCall;
    }
    clearTimeout(timeout);
    timeout = null;
    const args = pendingArgs;
    pendingArgs = null;
    lastCall = immediate ? undefined : func.apply(pendingContext, args);
    return lastCall;
  };

  return debounced;
}
